export default "__VITE_ASSET__Dl7I_Cxm__"